import { EntityInfoType } from "@app/entity/model/entityinfo";
import { createFailureAction, createNoPropsAction, createSuccessAction } from "@app/root-store/actions/action-creators";
import { ClareDbCollection } from "@app/shared/resources/resource-objectifier";

const actionCategory = "EntityInfoManagement";
export interface BulkActionResult {
    entityinfotypes: ClareDbCollection<EntityInfoType>;
}

const load = createNoPropsAction(actionCategory, "Load");
const loadSuccess = createSuccessAction<BulkActionResult>(actionCategory, "Load");
const loadFailure = createFailureAction(actionCategory, "Load");

export const loadSet = { request: load, success: loadSuccess, failure: loadFailure };
